import React, { FC } from 'react'

import {
  PublicWorkspaceFragment,
  WorkspaceMinimalFragment,
} from '@sketch/gql-types'
import { DocumentSidebarLayoutHeaderProps } from 'containers/DocumentSidebarLayout'
import HeaderWorkspaceBadge from '../HeaderWorkspaceBadge'
import SketchHomeButton from 'components/SketchHomeButton'

export interface HeaderBadgeProps {
  type: 'workspace' | 'home'
  setSidebarLeftOpen: DocumentSidebarLayoutHeaderProps['setSidebarLeftOpen']
  workspace: PublicWorkspaceFragment | WorkspaceMinimalFragment
}

const HeaderBadge: FC<HeaderBadgeProps> = props =>
  props.type === 'workspace' ? (
    <HeaderWorkspaceBadge
      setSidebarLeftOpen={props.setSidebarLeftOpen}
      workspace={props.workspace}
    />
  ) : (
    <SketchHomeButton />
  )

export default HeaderBadge
